import areIntlLocalesSupported from 'intl-locales-supported';

export default class DateTimeFormatter {

    getDateTimeFormat(locale) {

        let dateTimeFormat;

        if (areIntlLocalesSupported([locale])) {
            dateTimeFormat = global.Intl.DateTimeFormat;
        }
        else {

            // TODO: add support for all languages that not supported but the browser.
            // const IntlPolyfill = require('intl');
            // dateTimeFormat = IntlPolyfill.DateTimeFormat;
            // example:
            // require(`intl/locale-data/jsonp/en-US.js`);
            // require(`intl/locale-data/jsonp/ar-EG.js`);
            // require(`intl/locale-data/jsonp/ko-KR.js`);
        }

        return dateTimeFormat;
    }
    
    toLocaleString(datetime) {

        let date = new Date(datetime);

        var navigatorLocale = window.navigator.language;

        var options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };

        return date.toLocaleString(navigatorLocale, options);
    }
}